import { RootState } from '@/shared/types/state';

export const clipboardSelector = (state: RootState) => state.clipboard.clipboard;
